import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { Title } from '@angular/platform-browser';
import { GeoService } from 'src/app/services/geo.service';
import { AWBDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/awb-delete.component';


@Component({
  selector: 'app-pincodes',
  templateUrl: './pincodes.component.html',
  styleUrls: ['./pincodes.component.scss'],
})
export class ListPincodeComponent implements OnInit {
  productList = [];
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isActionAllowed = true;

  public isCollapsed = true;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
    filter: true
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight'
  }
  columnDefs = [
    { headerName: 'Pincode', field: 'pincode' },
    { headerName: 'Country', field: 'countryname'},
    { headerName: 'State', field: 'statename' },
    { headerName: 'City', field: 'cityname' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: AWBDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 150,
    },
  ];
  rowData = [];

  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private geoService: GeoService,
    private titleService: Title
  ) {
    titleService.setTitle('Pincodes')
    this.context = { componentParent: this };
  }

  ngOnInit() {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.bindProductList();
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Pincodes');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindProductList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.geoService.GetAllPincodesList({ refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;
        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    // console.log(cell);
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/setup/pincodes/edit', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }

  }

  redirectToImport() {
    this.router.navigate(['../config/import'], { state: { redirectFrom: 'pincodes' } });
  }

  deleteAction(cell: any) {
    // console.log(cell);
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }

  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.geoService.DeletePincodeById(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Deleted Successfully', 'Success')
            this.bindProductList();
          }
          else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Cannot delete !', 'error')
          }
        });
      }
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteRecord(id);
    }
  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }
}
